export default __webpack_public_path__ + "static/media/Instagram2.c1352fb8.png";